var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Eye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 12,
    viewBox: "0 0 16.5 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6f6f6f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-eye",
    className: "cls-1",
    d: "M9.25,4C3.25,4,1,10,1,10s2.25,6,8.25,6,8.25-6,8.25-6S15.25,4,9.25,4Zm0,1.5c3.957,0,5.958,3.2,6.606,4.5-.649,1.288-2.665,4.5-6.606,4.5-3.957,0-5.958-3.2-6.606-4.5C3.293,8.715,5.309,5.5,9.25,5.5Zm0,1.5a3,3,0,1,0,3,3A3,3,0,0,0,9.25,7Zm0,1.5A1.5,1.5,0,1,1,7.75,10,1.5,1.5,0,0,1,9.25,8.5Z",
    transform: "translate(-1 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Eye);
export default __webpack_public_path__ + "static/media/icons8-eye.58721470e66c70b29560189b2e6c8092.svg";
export { ForwardRef as ReactComponent };